import { FetchError } from "utils/errors";

type VerifyPylonUserResponse = {
  hash: string;
};

const usePylonAuthentication = () => {
  const verifyPylonUser = async (email: string): Promise<VerifyPylonUserResponse> => {
    const response = await fetch("/pylon/verification", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        message: email,
      }),
    });

    if (!response.ok) {
      throw new FetchError(response.status);
    }

    const responseJson = await response.json();

    return {
      hash: responseJson.hashed,
    };
  };

  return {
    verifyPylonUser,
  };
};

export default usePylonAuthentication;
